export const handleError = (error, contextMessage = 'Request failed') => {
    if (error.response) {
        const { status, data } = error.response;
        const details =
            data?.message || (Array.isArray(data?.errors) ? data.errors.join(', ') : 'Unknown error');

        console.log(`${contextMessage} (status: ${status}) - ${details}`)
        throw new Error(`${details}`);
    }

    if (error.request) {
        throw new Error(`${contextMessage}: No response from server`);
    }

    throw new Error(`${contextMessage}: ${error.message || 'Unexpected error'}`);
};
